"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SquaredText;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function SquaredText(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: Object.assign({
      border: 'solid 1px #ced6dc',
      borderRadius: 2,
      padding: 3,
      margin: 2,
      display: 'inline-flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center'
    }, style)
  }, children);
}